/**
 * Lightens a hex color by a given percentage
 */
export const lightenColor = (color: string, percent: number) => {
  const num = parseInt(color.replace('#', ''), 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) + amt,
    G = ((num >> 8) & 0x00ff) + amt,
    B = (num & 0x0000ff) + amt;
  return (
    '#' +
    (
      0x1000000 +
      (R < 255 ? R : 255) * 0x10000 +
      (G < 255 ? G : 255) * 0x100 +
      (B < 255 ? B : 255)
    )
      .toString(16)
      .slice(1)
  );
};

/**
 * Darkens a hex color by a given percentage
 */
export const darkenColor = (color: string, percent: number) => {
  const num = parseInt(color.replace('#', ''), 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) - amt,
    G = ((num >> 8) & 0x00ff) - amt,
    B = (num & 0x0000ff) - amt;
  return (
    '#' +
    (
      0x1000000 +
      (R > 0 ? R : 0) * 0x10000 +
      (G > 0 ? G : 0) * 0x100 +
      (B > 0 ? B : 0)
    )
      .toString(16)
      .slice(1)
  );
};

/**
 * Creates a gradient style for a color
 */
export const getGradientStyle = (
  color: string,
  variant: 'solid' | 'line' = 'solid'
) => {
  const lighterColor = lightenColor(color, 20);
  const darkerColor = darkenColor(color, 10);

  if (variant === 'line') {
    return {
      background: `linear-gradient(to bottom, ${lighterColor}, ${color}, ${darkerColor})`,
      borderRadius: '1px',
    };
  } else {
    // solid with gradient
    return {
      background: `linear-gradient(135deg, ${lighterColor}, ${color}, ${darkerColor})`,
      boxShadow: `0 0 2px rgba(0, 0, 0, 0.08)`,
    };
  }
};
